import { ChartBar, Cube } from '@phosphor-icons/react';
import type { PoolResponse } from '../../services/api.js';
import { formatCoinAmount } from '../../utils/format.js';

const PERIODS = [
  { label: 'Последние 60 минут', index: 0 },
  { label: 'Последние 12 часов', index: 1 },
  { label: 'Последние 24 часа', index: 2 },
  { label: 'Сегодня', index: 3 },
  { label: 'Вчера', index: 4 },
  { label: 'Предыдущие 7 дней', index: 5 },
  { label: 'Предыдущие 30 дней', index: 6 },
];

interface Props {
  pool: PoolResponse | null;
  usdRub: number;
}

export function EarningsPage({ pool, usdRub }: Props) {
  const coinSymbol = pool?.pool.coinSymbol ?? 'XEL';
  const coinPrice = pool ? parseFloat(pool.pool.coinPriceUsd) : 0;
  const totalBlocks = pool?.miner.totalBlocksFound ?? 0;

  return (
    <>
      <div class="section-header">
        {pool && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)', flexWrap: 'wrap' }}>
            <div class="coin-badge">
              <span>{coinSymbol}</span>
              <span style={{ color: 'var(--lime)' }}>${coinPrice.toFixed(2)}</span>
            </div>
            <div class="coin-badge">
              <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Cube size={12} weight="duotone" />
                Блоков
              </span>
              <span style={{ color: 'var(--purple)' }}>{totalBlocks}</span>
            </div>
          </div>
        )}
      </div>

      <div class="data-card">
        <div class="data-card-header">
          <ChartBar size={16} />
          <span>Вознаграждения по периодам</span>
        </div>
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>Период</th>
                <th>Вознаграждение</th>
                <th style={{ textAlign: 'center' }}>Блоки</th>
                <th>USD / RUB</th>
              </tr>
            </thead>
            <tbody>
              {pool
                ? PERIODS.map((period) => {
                    const reward = pool.miner.sumrewards[period.index]?.reward ?? 0;
                    const coinAmount = formatCoinAmount(reward);
                    const usd = (reward / 1e8) * coinPrice;
                    const rub = usd * usdRub;
                    const blocks = pool.miner.blocksSumRewards?.[period.index]?.reward ?? 0;

                    return (
                      <tr key={period.index}>
                        <td>{period.label}</td>
                        <td style={{ fontFamily: 'var(--font-mono)' }}>{coinAmount}</td>
                        <td style={{ textAlign: 'center', fontFamily: 'var(--font-mono)', color: blocks > 0 ? 'var(--purple)' : 'var(--tx-muted)', fontWeight: blocks > 0 ? 600 : 400 }}>
                          {blocks > 0 ? blocks : '—'}
                        </td>
                        <td style={{ fontFamily: 'var(--font-mono)' }}>
                          <span style={{ color: 'var(--lime)' }}>${usd.toFixed(2)}</span>
                          {' / '}
                          <span style={{ color: 'var(--cyan)' }}>{rub.toFixed(0)} ₽</span>
                        </td>
                      </tr>
                    );
                  })
                : Array.from({ length: 7 }, (_, i) => (
                    <tr key={i}>
                      <td colSpan={4} style={{ textAlign: 'center', color: 'var(--tx-muted)' }}>
                        Загрузка...
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
